export enum InvoicesType {
  Approved = 1,
  New = 0,
  Deleted = -1
}
